// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"834bd7e2","261":"09d1fc54","386":"8403f16b","424":"3e7e685e","453":"8ab44547","602":"233cefb3","913":"10b7eb73"}[chunkId] + ".chunk.js";
};